import { render, staticRenderFns } from "./UserPostGrid.vue?vue&type=template&id=361ef3a1&"
import script from "./UserPostGrid.vue?vue&type=script&lang=js&"
export * from "./UserPostGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports